<mat-card class="dashboard-container">
  <mat-card-content>
    <div fxLayout="row wrap" fxLayoutGap="20px" fxLayoutAlign="start stretch">
      @for (config of statisticsCardConfigs; track config) {
        <mat-card
          class="stat-card"
          fxLayout="column"
          fxLayoutAlign="center center"
          [class.disabled]="config.disabled"
          [attr.disabled]="config.disabled ? true : null"
          [routerLink]="config.disabled ? null : config.route"
          >
          <mat-icon>{{ config.icon }}</mat-icon>
          <mat-card-title>{{ config.name }}</mat-card-title>
        </mat-card>
      }
    </div>
  </mat-card-content>
</mat-card>

<router-outlet></router-outlet>
